export default "__VITE_ASSET__DoRmj1kN__"